// src/components/organisms/AdvancedFilters/AdvancedFilters.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Divider,
  useTheme
} from '@mui/material';
import {
  Clear as ClearIcon,
  FilterList as FilterIcon,
  Save as SaveIcon,
  RestoreFromTrash as ResetIcon,
  YouTube as YouTubeIcon,
  X as XIcon,
  Instagram as InstagramIcon,
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  Language as WebIcon,
  Article as ArticleIcon,
  VideoLibrary as VideoIcon,
  SmartDisplay as ShortIcon,
  PhotoLibrary as ReelIcon,
  Image as PostIcon,
  Upload as UploadIcon,
  MusicNote as TikTokIcon,
  Groups as SocialIcon,
  Newspaper as NewspaperIcon,
  MenuBook as MagazineIcon,
  Tv as TvIcon,
  Radio as RadioIcon,
  Podcasts as PodcastIcon
} from '@mui/icons-material';
import ActiveFilterCountChip from '../../molecules/ActiveFilterCountChip';
import DateFilter from '../../molecules/DateFilter/DateFilter';
import FilterPresetChip from '../../molecules/FilterPresetChip';
import FilterHeaderActionButton from '../../molecules/FilterHeaderActionButton';
import MultiSelectFilter from '../../molecules/MultiSelectFilter/MultiSelectFilter';
import SearchableMultiSelectFilter from '../../molecules/SearchableMultiSelectFilter/SearchableMultiSelectFilter';
import {
  operationalComponentSurfaces,
  operationalRadii
} from '../../../design-system/tokens';

// Ãcone customizado para Pinterest
const PinterestIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" {...props}>
    <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
  </svg>
);

// Ãcone customizado para Threads (logo oficial da Meta)
const CustomThreadsIcon = (props) => (
  <svg viewBox="0 0 192 192" width="1em" height="1em" fill="currentColor" {...props}>
    <path d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"/>
  </svg>
);

/**
 * AdvancedFilters - Componente organismo para filtros avançados
 * 
 * Este componente combina diversos filtros para formar a barra de
 * filtros avançados da aplicação. Segue o princípio do Atomic Design
 * como um "organismo".
 * 
 * MELHORIAS IMPLEMENTADAS:
 * - Filtros adicionais (Status, Data de Criação, Última Modificação)
 * - Filtros por texto (busca em título, conteÃºdo, descrição)
 * - Filtros rápidos (presets)
 * - Botão de limpar filtros
 * - Contador de filtros ativos
 * - Melhor organização visual
 * - Compatibilidade com design system
 */
const AdvancedFilters = ({
  dateValue,
  onDateChange,
  dateOptions,
  
  selectedSources,
  onSourcesChange,
  sourceOptions,
  
  selectedSentiments,
  onSentimentsChange,
  sentimentOptions,

  selectedExposures,
  onExposuresChange,
  exposureOptions,
  
  selectedTags,
  onTagsChange,
  tagOptions,
  
  selectedCollections,
  onCollectionsChange,
  collectionOptions,

  // Filtro de Plataforma
  selectedMediaTypes,
  onMediaTypesChange,
  mediaTypeOptions,

  // Filtro de Formato
  selectedContentTypes,
  onContentTypesChange,
  contentTypeOptions,

  // Filtro de Tier (Valoração)
  selectedTiers,
  onTiersChange,
  tierOptions,

  // Filtro de Tipo de Marca (Minha Marca vs Concorrentes)
  selectedEntityType,
  onEntityTypeChange,
  entityTypeOptions,
  
  // Novos filtros
  selectedStatuses,
  onStatusesChange,
  statusOptions,
  
  selectedCreatedDates,
  onCreatedDatesChange,
  createdDateOptions,
  
  selectedModifiedDates,
  onModifiedDatesChange,
  modifiedDateOptions,
  
  textSearchValue,
  onTextSearchChange,
  textSearchOptions,
  
  showTagFilter = true,
  showCollectionFilter = true,

  // Ações
  onClearFilters,
  onSaveFilters,
  onResetFilters,

  // Controle de exibição
  hideHeader = false,

  className = '',
  ...props
}) => {
  const theme = useTheme();

  // Contar filtros ativos
  const getActiveFiltersCount = () => {
    let count = 0;
    if (dateValue) count++;
    if (selectedSources?.length > 0) count++;
    if (selectedSentiments?.length > 0) count++;
    if (selectedExposures?.length > 0) count++;
    if (selectedTags?.length > 0) count++;
    if (selectedCollections?.length > 0) count++;
    if (selectedMediaTypes?.length > 0) count++;
    if (selectedContentTypes?.length > 0) count++;
    if (selectedTiers?.length > 0) count++;
    if (selectedEntityType) count++;
    if (selectedStatuses?.length > 0) count++;
    if (selectedCreatedDates?.length > 0) count++;
    if (selectedModifiedDates?.length > 0) count++;
    if (textSearchValue) count++;
    return count;
  };

  const activeFiltersCount = getActiveFiltersCount();
  const toggleStatusPreset = (status) => {
    if (!onStatusesChange) return;
    onStatusesChange(selectedStatuses?.includes(status) ? [] : [status]);
  };

  return (
    <Box
      className={`advanced-filters ${className}`}
      sx={{
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: theme.palette.mode === 'dark'
          ? operationalComponentSurfaces.filterPanel.dark
          : operationalComponentSurfaces.filterPanel.light,
        backdropFilter: 'none',
        WebkitBackdropFilter: 'none',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: `${operationalRadii.surface}px`,
        p: 2,
        transition: 'background-color 0.18s ease, border-color 0.18s ease',
        '&:hover': {
          backgroundColor: theme.palette.mode === 'dark'
            ? operationalComponentSurfaces.filterPanel.darkHover
            : operationalComponentSurfaces.filterPanel.lightHover,
          border: `1px solid ${theme.palette.mode === 'dark'
            ? operationalComponentSurfaces.filterPanel.darkHoverBorder
            : operationalComponentSurfaces.filterPanel.lightHoverBorder}`,
        }
      }}
      {...props}
    >
      {/* Header dos Filtros - escondido quando usado dentro de FilterDialog */}
      {!hideHeader && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FilterIcon color="primary" />
            <Typography variant="h6" fontWeight={600} color={theme.palette.text.primary}>
              Filtros Avançados
            </Typography>
            <ActiveFilterCountChip count={activeFiltersCount} />
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <FilterHeaderActionButton
              tooltip="Limpar todos os filtros"
              label="Limpar"
              icon={<ClearIcon />}
              tone="clear"
              onClick={onClearFilters}
              disabled={activeFiltersCount === 0}
            />

            {onSaveFilters && (
              <FilterHeaderActionButton
                tooltip="Salvar configuração de filtros"
                label="Salvar"
                icon={<SaveIcon />}
                tone="primary"
                onClick={onSaveFilters}
              />
            )}

            {onResetFilters && (
              <FilterHeaderActionButton
                tooltip="Restaurar filtros padrão"
                label="Resetar"
                icon={<ResetIcon />}
                tone="secondary"
                onClick={onResetFilters}
              />
            )}
          </Box>
        </Box>
      )}

      <Divider sx={{ borderColor: theme.palette.divider }} />

      {/* Filtros em Grid */}
      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: 2 
      }}>
        {/* Filtro de Data de Publicação */}
        <DateFilter
          value={dateValue}
          onChange={onDateChange}
          options={dateOptions}
          label="Data de Publicação"
        />
        
        {/* Filtro de Data de Criação */}
        {onCreatedDatesChange && (
          <DateFilter
            value={selectedCreatedDates}
            onChange={onCreatedDatesChange}
            options={createdDateOptions}
            label="Data de Criação"
          />
        )}
        
        {/* Filtro de Última Modificação */}
        {onModifiedDatesChange && (
          <DateFilter
            value={selectedModifiedDates}
            onChange={onModifiedDatesChange}
            options={modifiedDateOptions}
            label="Última Modificação"
          />
        )}

        {/* Filtro de Plataforma */}
        <MultiSelectFilter
          value={selectedMediaTypes}
          onChange={onMediaTypesChange}
          options={mediaTypeOptions}
          label="Plataforma"
        />

        {/* Filtro de Formato */}
        {onContentTypesChange && (
          <MultiSelectFilter
            value={selectedContentTypes}
            onChange={onContentTypesChange}
            options={contentTypeOptions}
            label="Formato"
          />
        )}

        {/* Filtro de Tier (Valoração) */}
        <MultiSelectFilter
          value={selectedTiers}
          onChange={onTiersChange}
          options={tierOptions}
          label="Tier"
        />

        {/* Filtro de Tipo de Marca (Minha Marca vs Concorrentes) */}
        {entityTypeOptions?.length > 0 && onEntityTypeChange && (
          <MultiSelectFilter
            value={selectedEntityType ? [selectedEntityType] : []}
            onChange={(vals) => {
              const next = vals[vals.length - 1] || '';
              onEntityTypeChange(next === selectedEntityType ? '' : next);
            }}
            options={entityTypeOptions}
            label="Tipo de Marca"
          />
        )}
        
        {/* Filtro de Fonte */}
        <SearchableMultiSelectFilter
          value={selectedSources}
          onChange={onSourcesChange}
          options={sourceOptions}
          label="Fonte"
          placeholder="Buscar fontes..."
        />
        
        {/* Filtro de Sentimento */}
        <MultiSelectFilter
          value={selectedSentiments}
          onChange={onSentimentsChange}
          options={sentimentOptions}
          label="Sentimento"
        />

        {/* Filtro de Exposição */}
        {onExposuresChange && (
          <MultiSelectFilter
            value={selectedExposures}
            onChange={onExposuresChange}
            options={exposureOptions}
            label="Exposição"
          />
        )}
        
        {/* Filtro de Status */}
        {onStatusesChange && (
          <MultiSelectFilter
            value={selectedStatuses}
            onChange={onStatusesChange}
            options={statusOptions}
            label="Status"
          />
        )}
        
        {/* Filtro de Tag (condicional) */}
        {showTagFilter && (
          <SearchableMultiSelectFilter
            value={selectedTags}
            onChange={onTagsChange}
            options={tagOptions}
            label="Tags"
            placeholder="Buscar tags..."
          />
        )}
        
        {/* Filtro de Coleção (condicional) */}
        {showCollectionFilter && (
          <MultiSelectFilter
            value={selectedCollections}
            onChange={onCollectionsChange}
            options={collectionOptions}
            label="Coleções"
          />
        )}
        
        {/* Filtro de Busca por Texto */}
        {onTextSearchChange && (
          <MultiSelectFilter
            value={textSearchValue}
            onChange={onTextSearchChange}
            options={textSearchOptions}
            label="Busca por Texto"
            placeholder="Buscar em título, conteÃºdo..."
          />
        )}
      </Box>

      {/* Filtros Rápidos (Presets) */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Typography 
          variant="body2" 
          fontWeight={600} 
          sx={{ 
            mr: 1, 
            alignSelf: 'center',
            color: theme.palette.text.secondary
          }}
        >
          Filtros Rápidos:
        </Typography>
        
        <FilterPresetChip
          label="Não Lidos"
          active={selectedStatuses?.includes('unread')}
          onClick={() => toggleStatusPreset('unread')}
        />
        
        <FilterPresetChip
          label="Favoritos"
          active={selectedStatuses?.includes('favorite')}
          onClick={() => toggleStatusPreset('favorite')}
        />
        
        <FilterPresetChip
          label="Com Imagem"
          active={selectedStatuses?.includes('with_image')}
          onClick={() => toggleStatusPreset('with_image')}
        />
        
        <FilterPresetChip
          label="Sem Tags"
          active={selectedStatuses?.includes('no_tags')}
          onClick={() => toggleStatusPreset('no_tags')}
        />

        <FilterPresetChip
          label="Area Editorial Pendente"
          active={selectedStatuses?.includes('editorial_pending')}
          onClick={() => toggleStatusPreset('editorial_pending')}
        />

        <FilterPresetChip
          label="IA Pendente"
          active={selectedStatuses?.includes('kpia_pending')}
          onClick={() => toggleStatusPreset('kpia_pending')}
        />

        <FilterPresetChip
          label="IA Aplicada"
          active={selectedStatuses?.includes('kpia_applied')}
          activeColor="success"
          hoverColor={theme.palette.success.main}
          onClick={() => toggleStatusPreset('kpia_applied')}
        />
        
        <FilterPresetChip
          label="Última Semana"
          active={dateValue === 'last_week'}
          activeColor="success"
          hoverColor={theme.palette.success.main}
          onClick={() => onDateChange?.('last_week')}
        />
      </Box>
    </Box>
  );
};

AdvancedFilters.propTypes = {
  dateValue: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  dateOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  
  selectedSources: PropTypes.array,
  onSourcesChange: PropTypes.func.isRequired,
  sourceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  
  selectedSentiments: PropTypes.array,
  onSentimentsChange: PropTypes.func.isRequired,
  sentimentOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,

  selectedExposures: PropTypes.array,
  onExposuresChange: PropTypes.func,
  exposureOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  
  selectedTags: PropTypes.array,
  onTagsChange: PropTypes.func.isRequired,
  tagOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  
  selectedCollections: PropTypes.array,
  onCollectionsChange: PropTypes.func.isRequired,
  collectionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,

  // Filtro de Plataforma
  selectedMediaTypes: PropTypes.array,
  onMediaTypesChange: PropTypes.func.isRequired,
  mediaTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,

  // Filtro de Formato
  selectedContentTypes: PropTypes.array,
  onContentTypesChange: PropTypes.func,
  contentTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),

  // Filtro de Tipo de Marca
  selectedEntityType: PropTypes.string,
  onEntityTypeChange: PropTypes.func,
  entityTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),

  // Novos filtros
  selectedStatuses: PropTypes.array,
  onStatusesChange: PropTypes.func,
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  
  selectedCreatedDates: PropTypes.array,
  onCreatedDatesChange: PropTypes.func,
  createdDateOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  
  selectedModifiedDates: PropTypes.array,
  onModifiedDatesChange: PropTypes.func,
  modifiedDateOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  
  textSearchValue: PropTypes.string,
  onTextSearchChange: PropTypes.func,
  textSearchOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  
  showTagFilter: PropTypes.bool,
  showCollectionFilter: PropTypes.bool,
  
  // Ações
  onClearFilters: PropTypes.func,
  onSaveFilters: PropTypes.func,
  onResetFilters: PropTypes.func,

  // Controle de exibição
  hideHeader: PropTypes.bool,

  className: PropTypes.string
};

// Valores padrão para as opções
AdvancedFilters.defaultProps = {
  dateOptions: [
    { value: 'last_day', label: 'Último dia' },
    { value: 'last_week', label: 'Última semana' },
    { value: 'last_month', label: 'Último mÃªs' },
    { value: 'last_3_months', label: 'Últimos 3 meses' },
    { value: 'last_year', label: 'Último ano' },
    { value: 'custom', label: 'Personalizado' }
  ],
  sentimentOptions: [
    { value: 'positive', label: 'Positivo' },
    { value: 'neutral', label: 'Neutro' },
    { value: 'negative', label: 'Negativo' }
  ],
  mediaTypeOptions: [
    { value: 'Online', label: 'Online', icon: <WebIcon sx={{ fontSize: 18 }} /> },
    { value: 'YouTube', label: 'YouTube', icon: <YouTubeIcon sx={{ fontSize: 18 }} /> },
    { value: 'Twitter', label: 'Twitter/X', icon: <XIcon sx={{ fontSize: 18 }} /> },
    { value: 'Instagram', label: 'Instagram', icon: <InstagramIcon sx={{ fontSize: 18 }} /> },
    { value: 'TikTok', label: 'TikTok', icon: <TikTokIcon sx={{ fontSize: 18 }} /> },
    { value: 'Facebook', label: 'Facebook', icon: <FacebookIcon sx={{ fontSize: 18 }} /> },
    { value: 'LinkedIn', label: 'LinkedIn', icon: <LinkedInIcon sx={{ fontSize: 18 }} /> },
    { value: 'Pinterest', label: 'Pinterest', icon: <PinterestIcon style={{ fontSize: 18 }} /> },
    { value: 'Threads', label: 'Threads', icon: <CustomThreadsIcon style={{ fontSize: 18 }} /> },
    // Mídias Impressas
    { value: 'Jornal', label: 'Jornal', icon: <NewspaperIcon sx={{ fontSize: 18 }} /> },
    { value: 'Revista', label: 'Revista', icon: <MagazineIcon sx={{ fontSize: 18 }} /> },
    // Mídias EletrÃ´nicas
    { value: 'TV', label: 'TV', icon: <TvIcon sx={{ fontSize: 18 }} /> },
    { value: 'Radio', label: 'Rádio', icon: <RadioIcon sx={{ fontSize: 18 }} /> },
    { value: 'Podcast', label: 'Podcast', icon: <PodcastIcon sx={{ fontSize: 18 }} /> }
  ],
  contentTypeOptions: [
    { value: 'article', label: 'Artigo', icon: <ArticleIcon sx={{ fontSize: 18 }} /> },
    { value: 'video', label: 'Vídeo', icon: <VideoIcon sx={{ fontSize: 18 }} /> },
    { value: 'short', label: 'Short', icon: <ShortIcon sx={{ fontSize: 18 }} /> },
    { value: 'reel', label: 'Reel', icon: <ReelIcon sx={{ fontSize: 18 }} /> },
    { value: 'post', label: 'Post', icon: <PostIcon sx={{ fontSize: 18 }} /> },
    { value: 'pin', label: 'Pin', icon: <PinterestIcon style={{ fontSize: 18 }} /> },
    { value: 'tweet', label: 'Tweet', icon: <XIcon sx={{ fontSize: 18 }} /> },
    { value: 'social', label: 'Social', icon: <SocialIcon sx={{ fontSize: 18 }} /> },
    { value: 'upload', label: 'Upload', icon: <UploadIcon sx={{ fontSize: 18 }} /> }
  ],
  statusOptions: [
    { value: 'read', label: 'Lido' },
    { value: 'unread', label: 'Não Lido' },
    { value: 'favorite', label: 'Favorito' },
    { value: 'not_favorite', label: 'Não Favorito' },
    { value: 'with_image', label: 'Com Imagem' },
    { value: 'without_image', label: 'Sem Imagem' },
    { value: 'with_tags', label: 'Com Tags' },
    { value: 'no_tags', label: 'Sem Tags' },
    { value: 'editorial_pending', label: 'Area Editorial Pendente' },
    { value: 'editorial_complete', label: 'Com Area Editorial' }
  ],
  textSearchOptions: [
    { value: 'title', label: 'Título' },
    { value: 'content', label: 'ConteÃºdo' },
    { value: 'description', label: 'Descrição' },
    { value: 'author', label: 'Autor' },
    { value: 'all', label: 'Todos os Campos' }
  ]
};

export default AdvancedFilters;

